// ── Store links ─────────────────────────────────────────────────────────────
//
// The public pages end in the same two listings, and they have to be right
// without any app state: a wrong URL here is a dead install loop rather than a
// recoverable error. Kept in one module so the pages cannot drift to different
// campaign names.
//
// The invoice viewer is no longer one of them — it lives in the web app and
// carries its own copy of this rule (`WebApp/src/utils/store-links.ts`), with
// the same `invoice` campaign name so both still read as one report.

export const APP_STORE_URL = "https://apps.apple.com/in/app/id6463052653";

export const PLAY_STORE_URL =
	"https://play.google.com/store/apps/details?id=os.pokledlite";

/**
 * The Play listing carrying `code` as campaign, so an install from this page
 * arrives in the app already knowing who sent it.
 *
 * Play is the only one of the two stores that carries an install referrer. iOS
 * links ignore every parameter — its handoff is the copied code, which is why
 * every page prints it and both apps have a Paste button next to the field.
 */
export function playStoreUrl(code: string, source: string): string {
	const referrer = [
		`utm_source=${encodeURIComponent(source)}`,
		"utm_medium=link",
		`utm_campaign=${encodeURIComponent(code)}`,
	].join("&");
	return `${PLAY_STORE_URL}&referrer=${encodeURIComponent(referrer)}`;
}
